import "%components%/hamburger/hamburger";

import "%components%/gallery/gallery";
import "%components%/logo/logo";
